export default __webpack_public_path__ + "static/media/discountIcon.76d87500.svg";